<footer id="footer" class="footer main dark-background">

  <div class="container footer-top">
    <div class="row gy-4 d-flex justify-content-between">
      <div class="col-lg-4 col-md-6 footer-about">
        <a routerLink="/Home">
          <!-- Uncomment the line below if you also wish to use an image logo -->
          <img src="assets/img/logo.png" alt="Logo" style="width: auto;" height="70px">
        </a>
        <p style="color: color-mix(in srgb, var(--default-color), transparent 30%); margin-top: 20px;">
          Unsere Vision ist es, der führende Anbieter von qualifizierten Fachkräften in Deutschland zu sein. Wir streben an, Arbeitssuchende und Arbeitgeber auf die effizienteste Weise miteinander zu verbinden.
        </p>
      </div>
      <div class="col-lg-2 col-md-3 footer-links">
        <h4>Kontaktieren Sie uns</h4>
        <div class="footer-contact pt-3">
          <p><strong>Address:</strong> {{companyInfo?.address}}</p>
          <p class="mt-3"><strong>Telefon:</strong> <span>{{companyInfo?.phoneNumber}}</span></p>
          <p><strong>E-Mail:</strong> <span>{{companyInfo?.email}}</span></p>
        </div>
        <div class="social-links d-flex mt-4">
          <a [href]="account.url" target="_blank" *ngFor="let account of socialMediaAccounts"><i class="{{ sharedService.getPlatformIcon(account.platform) }}"></i></a>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 footer-links">
        <h4>Nützliche Links</h4>
        <ul>
          <li><a routerLink="/Home" class="active">Startseite</a></li>
          <li><a routerLink="/About">Über uns</a></li>
          <li><a routerLink="/WhowItWork">So funktioniert's</a></li>
          <li><a routerLink="/Privacy">Datenschutz</a></li>
          <li><a routerLink="/Contact">Kontakt</a></li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-3 footer-links">
        <h4>Unsere Dienstleistungen</h4>
        <ul>
          <li *ngFor="let catigory of categories">
            <a [routerLink]="['/Jobs', catigory]">{{catigory}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container copyright text-center mt-4">
    <p>© <span>Urheberrecht</span><a routerLink="/Home"> <strong class="px-1" style="color: #D4AF37;">Ab Nach Deutschland</strong> </a><span>Alle Rechte vorbehalten</span></p>
  </div>

</footer>